export const PROD_CATEG_1 = prodGroup => new Set(["K01", "K09"]).has(prodGroup);
export const PROD_CATEG_2 = prodGroup =>
  new Set(["K02", "K04", "K06", "K10", "K11", "K12"]).has(prodGroup);
export const SALE_CATEG_1 = (unit: string) => new Set(["RM", "TON"]).has(unit);

export const getSalesUnit = (salesUnit, priceGroup) => {
  if (PROD_CATEG_1(priceGroup)) {
    return "ROL";
  }
  return salesUnit;
};
